import React from 'react';
import Products from '../Products';

const ProductsPage: React.FC = () => <Products />;

export default ProductsPage;
